// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad6567a2","455":"e809e2e0","977":"3375f843"}[chunkId] + ".chunk.js";
};